// eslint-disable-next-line no-use-before-define
import { defTitle } from 'assets/strings';
import FormGenerator from 'components/Form/template/FormGenerator';
import SimplesForm from 'components/modal/template/simplesForm';
import React, { FC, memo, useEffect } from 'react';

const ComponentInserirSaldo: FC<any> = memo((oProps) => {
    useEffect(() => {
        // eslint-disable-next-line no-undef
        document.title = `${defTitle} - Ir para pagamento`;
    });
    return (
        <SimplesForm
            rForm={oProps.rForm}
            handleSubmit={oProps.handleSubmit}
            loading={oProps.loading}
            titleSubmit={'Ir para pagamento'}
            titleModal={'Adicionar saldo'}
            message="Selecione um dos valores abaixo para continuar. Você será redirecionado para a tela de pagamento em um ambiente totalmente seguro."
        >
            <div style={{ display: 'none' }}>
                {oProps?.user?.id}
            </div>
            <FormGenerator rForm={oProps.rForm} childs={oProps.inputs} />
        </SimplesForm>
    );
});
export default ComponentInserirSaldo;
